import React, {Component} from "react";
import Illus from "../../../illustration/Sneezing-rafiki.svg";
 

class AlertReq extends Component{

    constructor(props){
        super(props);
        this.state = {
        }
    }

    render(){
        return(
            <div className="breadcrumb-area">
                <div className="sec-bg breadcrumb-widget-card newsletter-area br-10">
                    <h4>Get Alerts for new IDOS & INOS</h4>
                    <div className="newsletter-flex">
                        <form action="#">
                            <i className="fi fi-rr-envelope"></i>
                            <input type="text" placeholder="Your Email Address" className="br-20" />
                            <button type="submit">Subscribe</button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default AlertReq;